<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ isEdit ? 'Editar Registro' : 'Nuevo Registro' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="py-md-1 my-md-n6">
            <v-col cols="12">
              <v-textarea
                v-model="localItem.motivo"
                rows="2"
                no-resize
                color="primary"
                :rules="[(v) => !!v || 'Motivo es requerido']"
                label="Motivo de Viaje"
                required
              />
            </v-col>
          </v-row>
          <v-row class="py-md-1 my-md-n6">
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="localItem.pais"
                :items="paises"
                :rules="[(v) => !!v || 'Pais es Requerido']"
                label="Pais"
                @change="onChangePais"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="localItem.pais == 187 || showLugar">
              <v-select
                v-model="localItem.iddepto"
                :items="departamentos"
                :rules="[(v) => !!v || 'Departamento es Requerido']"
                label="Departamento Destino"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="localItem.lugar"
                label="Lugar"
                :rules="[(v) => !!v || 'Lugar es Requerido']"
                @change="onChangeLugar"
                required
              />
            </v-col>
          </v-row>
          <v-row class="py-md-1 my-md-n6">
            <v-col cols="12">
              <v-text-field
                v-model="localItem.ruta_viaje"
                label="Ruta Viaje"
                :rules="[(v) => !!v || 'Ruta es Requerido']"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="localItem.resolucion"
                :items="resoluciones"
                :rules="[(v) => !!v || 'Resolución es Requerido']"
                label="Resolución"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="localItem.pais == 187 || showLugar">
              <v-select
                v-model="localItem.tv"
                :items="regionesNacionales"
                :rules="[(v) => !!v || 'Tipo de Viaje es Requerido']"
                label="Tipo de Viaje"
                @change="onChangeTipo"
                required
              />
              <v-checkbox
                v-model="localItem.distancia"
                v-if="showCheck"
                label="¿Es Menor a 100 Km?"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" v-else>
              <v-select
                v-model="localItem.tv"
                :items="regionesInternacionales"
                :rules="[(v) => !!v || 'Tipo de Viaje es Requerido']"
                label="Tipo de Viaje"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="localItem.idunidad"
                :items="unidades"
                :rules="[(v) => !!v || 'Unidad es Requerido']"
                label="Unidad"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="localItem.transporte"
                :items="transportes"
                :rules="[(v) => !!v || 'Transporte es Requerido']"
                label="Transporte"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="localItem.financiamiento"
                :items="financiamientos"
                :rules="[(v) => !!v || 'Financiamiento es Requerido']"
                label="Financiamiento"
                required
              />
            </v-col>
            <v-row class="py-md-0 my-md-n6">
              <v-col cols="12">
                <v-radio-group
                  v-model="localItem.radioPoa"
                  label="Se encuentra en el POA"
                  row
                  :rules="[(v) => !!v || 'Poa es Requerido']"
                  required
                >
                  <v-radio label="SI" value="1" />
                  <v-radio label="NO" value="2" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="py-md-3 my-md-n6">
              <v-col cols="12">
                <v-radio-group
                  v-model="localItem.radioRow"
                  label="Comisión de Viajes:"
                  row
                  :rules="[(v) => !!v || 'Financiamiento es Requerido']"
                  required
                >
                  <v-radio label="Ninguna" value="1" />
                  <v-radio label="Excepcion - (ART. 14 RPV)" value="2" />
                  <v-radio label="Extraordinario - (Instr. MAE)" value="3" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="py-md-1 my-md-n6">
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localItem.date"
                      label="Dia partida"
                      prepend-icon="calendar_month"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[(v) => !!v || 'Fecha es Requerido']"
                      required
                    />
                  </template>
                  <v-date-picker
                    v-model="localItem.date"
                    @input="menu = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="localItem.time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localItem.time"
                      label="Hora de Partida"
                      prepend-icon="schedule"
                      readonly
                      v-bind="attrs"
                      :rules="[(v) => !!v || 'Hora es Requerido']"
                      v-on="on"
                      required
                    />
                  </template>
                  <v-time-picker
                    v-if="menu3"
                    v-model="localItem.time"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu.save(localItem.time)"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="py-md-1 my-md-n6">
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localItem.date2"
                      label="Dia Retorno"
                      prepend-icon="calendar_month"
                      readonly
                      v-bind="attrs"
                      :rules="[(v) => !!v || 'Fecha es Requerido']"
                      v-on="on"
                      required
                    />
                  </template>
                  <v-date-picker
                    v-model="localItem.date2"
                    :min="localItem.date"
                    @input="menu2 = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu2"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="localItem.time2"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localItem.time2"
                      label="Hora de Retorno"
                      prepend-icon="schedule"
                      readonly
                      v-bind="attrs"
                      :rules="[(v) => !!v || 'Hora es Requerido']"
                      v-on="on"
                      required
                    />
                  </template>
                  <v-time-picker
                    v-if="menu4"
                    v-model="localItem.time2"
                    format="24hr"
                    full-width
                    @click:minute="$refs.menu2.save(localItem.time2)"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="onCancel">Cancelar</v-btn>
        <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  name: 'ViajeForm',
  props: {
    value: { type: Object, required: true },
    paises: { type: Array, required: true },
    departamentos: { type: Array, required: true },
    unidades: { type: Array, required: true },
    resoluciones: { type: Array, required: true },
    regionesNacionales: { type: Array, required: true },
    regionesInternacionales: { type: Array, required: true },
    transportes: { type: Array, required: true },
    financiamientos: { type: Array, required: true },
    showLugar: { type: Boolean, default: false },
    showCheck: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false }
  },
  data() {
    return {
      localItem: { ...this.value },
      valid: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localItem = { ...newVal };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.$emit('save', { ...this.localItem });
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onChangePais(valor) {
      this.$emit('change-pais', valor);
    },
    onChangeLugar(valor) {
      this.$emit('change-lugar', valor);
    },
    onChangeTipo(valor) {
      this.$emit('change-tipo', valor);
    }
  }
};
</script> 